// Team color palette, keyed by team label ('Red', 'Blue', …, 'Champion').
//   bright — vivid color for borders/chips/frames.
//   dark   — dark, white-text-readable variant for panel backgrounds.

const TEAM_BRIGHT = {
  Red: '#c0392b', Blue: '#2647c8', Green: '#2e9e2e', Yellow: '#b9960f',
  White: '#d9d9d9', Black: '#555', Purple: '#6a1b9a', Brown: '#6d4326', Champion: '#e07b1a',
};

const TEAM_DARK = {
  Red: '#4a1414', Blue: '#16263f', Green: '#143914', Yellow: '#322a08',
  White: '#383838', Black: '#161616', Purple: '#2a1240', Brown: '#2a1a0e', Champion: '#43290a',
};

export function teamBright(label) { return TEAM_BRIGHT[label] || '#888'; }
export function teamDark(label) { return TEAM_DARK[label] || 'rgba(12, 54, 80, 0.97)'; }

// Lowercase-keyed chip colors for the player/champion pages (muted team colors,
// readable as text-on-dark chips). Distinct from TEAM_BRIGHT (vivid bracket borders),
// and shared so the Champions / Players / champ-history views stay in sync.
export const COLOR_HEX = {
  red: '#c0392b', blue: '#2c6fbb', green: '#27913b', yellow: '#c9a227',
  white: '#aeb7c4', black: '#3b3f47', purple: '#8e44ad', brown: '#8a5a2b', champion: '#c79215',
};
